import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHEContainer } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { getUserManagerDetails, resetPassword, generateCode, updateUserManagerDetails } from '../../data/UsersManagers/actions';
import FormUserManager from './Form/FormUserManager';

class UserManagerDetail extends PureComponent {
    static propTypes = {
        updateUserManagerDetails: PropTypes.func.isRequired,
        getUserManagerDetails: PropTypes.func.isRequired,
        resetPassword: PropTypes.func.isRequired,
        generateCode: PropTypes.func.isRequired,
        userManagerId: PropTypes.string.isRequired,
        location: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { location } = this.props;
        this.state = {
            loading: location.firstPage || !(location.state && location.state.fromAdd),
            error: null
        };
    }

    componentDidMount() {
        const { location } = this.props;
        if (location.firstPage || !(location.state && location.state.fromAdd)) this.getUserManagerDetails();
    }

    getUserManagerDetails = () => {
        const { getUserManagerDetails, userManagerId } = this.props;
        this.setState({ loading: true, error: null });

        getUserManagerDetails(userManagerId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };

    updateUserManagerDetails = form => {
        const { updateUserManagerDetails, userManagerId } = this.props;
        return updateUserManagerDetails(userManagerId, form);
    };

    resetPassword = () => {
        const { resetPassword, userManagerId } = this.props;
        return resetPassword(userManagerId);
    };

    generateCode = () => {
        const { generateCode, userManagerId } = this.props;
        return generateCode(userManagerId);
    }

    renderChildren = () => {
        return <FormUserManager type="update" sendDataFunc={this.updateUserManagerDetails} resetPassword={this.resetPassword} generateCode={this.generateCode} />;
    };

    render() {
        const { loading, error } = this.state;

        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getUserManagerDetails} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    return {
        profile: state.data.user,
        userManagerId: props.match.params.userManagerId
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/UserManager/details',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, { getUserManagerDetails, resetPassword, generateCode, updateUserManagerDetails }),
                    dispatch
                )
        )(UserManagerDetail)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/UserManager/details.js